function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.708 10.292L39.708 0.292002C39.615 0.199198 39.5045 0.125642 39.3831 0.0755383C39.2616 0.0254349 39.1314 -0.000233099 39 1.59499e-06H15.298C14.4236 0.00106014 13.5854 0.348867 12.9671 0.967133C12.3489 1.5854 12.0011 2.42364 12 3.298V18H11C10.7633 18.0001 10.5343 18.0842 10.3538 18.2373C10.1732 18.3903 10.0528 18.6025 10.014 18.836L9.55 21.616C9.294 21.708 9.044 21.816 8.8 21.922L6.51 20.288C6.31748 20.1504 6.08241 20.0856 5.84658 20.105C5.61075 20.1244 5.38944 20.2268 5.222 20.394L2.4 23.222C2.2328 23.3894 2.13039 23.6108 2.11099 23.8466C2.09158 24.0824 2.15642 24.3175 2.294 24.51L3.922 26.8C3.812 27.044 3.708 27.294 3.616 27.55L0.836 28.014C0.602499 28.0528 0.390339 28.1732 0.23726 28.3538C0.0841807 28.5343 0.000108969 28.7633 0 29V33C0.000108969 33.2367 0.0841807 33.4657 0.23726 33.6462C0.390339 33.8268 0.602499 33.9472 0.836 33.986L3.616 34.45C3.708 34.706 3.816 34.956 3.922 35.2L2.288 37.49C2.15042 37.6825 2.08558 37.9176 2.10499 38.1534C2.12439 38.3893 2.2268 38.6106 2.394 38.778L5.222 41.6C5.38944 41.7672 5.61075 41.8696 5.84658 41.889C6.08241 41.9084 6.31748 41.8436 6.51 41.706L8.8 40.078C9.044 40.188 9.294 40.292 9.55 40.384L10.014 43.164C10.0528 43.3975 10.1732 43.6097 10.3538 43.7627C10.5343 43.9158 10.7633 43.9999 11 44H12V46.702C12.0011 47.5764 12.3489 48.4146 12.9671 49.0329C13.5854 49.6511 14.4236 49.9989 15.298 50H46.698C47.5731 50 48.4123 49.6527 49.0315 49.0343C49.6506 48.4159 49.9989 47.5771 50 46.702V11C50.0002 10.8686 49.9746 10.7384 49.9245 10.6169C49.8744 10.4955 49.8008 10.385 49.708 10.292ZM40 3.414L46.586 10H40V3.414ZM11.424 39.46C11.3942 39.2741 11.3125 39.1004 11.1883 38.9588C11.0641 38.8173 10.9025 38.7137 10.722 38.66C10.1899 38.5045 9.67576 38.2934 9.188 38.03C9.02313 37.9401 8.83627 37.8984 8.6488 37.9097C8.46134 37.921 8.28085 37.9849 8.128 38.094L6.038 39.6L4.4 37.962L5.894 35.872C6.00313 35.7192 6.06701 35.5387 6.07833 35.3512C6.08965 35.1637 6.04795 34.9769 5.958 34.812C5.69464 34.3242 5.48348 33.8101 5.328 33.278C5.27427 33.0975 5.17068 32.9359 5.02915 32.8117C4.88763 32.6875 4.71391 32.6058 4.528 32.576L2 32.154V29.846L4.54 29.424C4.72591 29.3942 4.89962 29.3125 5.04115 29.1883C5.18268 29.0641 5.28627 28.9025 5.34 28.722C5.49548 28.1899 5.70664 27.6758 5.97 27.188C6.05995 27.0231 6.10165 26.8363 6.09033 26.6488C6.07901 26.4613 6.01513 26.2808 5.906 26.128L4.4 24.038L6.032 22.406L8.122 23.9C8.27485 24.0091 8.45534 24.073 8.6428 24.0843C8.83027 24.0956 9.01713 24.0539 9.182 23.964C9.66976 23.7006 10.1839 23.4895 10.716 23.334C10.8965 23.2803 11.0581 23.1767 11.1823 23.0352C11.3065 22.8936 11.3882 22.7199 11.418 22.534L11.84 19.994H14.154L14.576 22.534C14.6058 22.7199 14.6875 22.8936 14.8117 23.0352C14.9359 23.1767 15.0975 23.2803 15.278 23.334C15.8101 23.4895 16.3242 23.7006 16.812 23.964C16.9769 24.0539 17.1637 24.0956 17.3512 24.0843C17.5387 24.073 17.7192 24.0091 17.872 23.9L19.962 22.406L21.594 24.038L20.1 26.128C19.9909 26.2808 19.927 26.4613 19.9157 26.6488C19.9044 26.8363 19.9461 27.0231 20.036 27.188C20.2994 27.6758 20.5105 28.1899 20.666 28.722C20.7197 28.9025 20.8233 29.0641 20.9648 29.1883C21.1064 29.3125 21.2801 29.3942 21.466 29.424L24.006 29.846V32.154L21.466 32.576C21.2801 32.6058 21.1064 32.6875 20.9648 32.8117C20.8233 32.9359 20.7197 33.0975 20.666 33.278C20.5105 33.8101 20.2994 34.3242 20.036 34.812C19.9461 34.9769 19.9044 35.1637 19.9157 35.3512C19.927 35.5387 19.9909 35.7192 20.1 35.872L21.594 37.962L19.962 39.594L17.872 38.1C17.7192 37.9909 17.5387 37.927 17.3512 37.9157C17.1637 37.9044 16.9769 37.9461 16.812 38.036C16.3242 38.2994 15.8101 38.5105 15.278 38.666C15.0975 38.7197 14.9359 38.8233 14.8117 38.9648C14.6875 39.1064 14.6058 39.2801 14.576 39.466L14.154 42H11.846L11.424 39.46ZM46.702 48H15.298C14.9539 47.9995 14.6241 47.8625 14.3808 47.6192C14.1375 47.3759 14.0005 47.0461 14 46.702V44H15C15.2367 43.9999 15.4657 43.9158 15.6462 43.7627C15.8268 43.6097 15.9472 43.3975 15.986 43.164L16.45 40.384C16.706 40.292 16.956 40.184 17.2 40.078L19.49 41.712C19.6825 41.8496 19.9176 41.9144 20.1534 41.895C20.3893 41.8756 20.6106 41.7732 20.778 41.606L23.6 38.778C23.7672 38.6106 23.8696 38.3893 23.889 38.1534C23.9084 37.9176 23.8436 37.6825 23.706 37.49L22.078 35.2C22.188 34.956 22.292 34.706 22.384 34.45L25.164 33.986C25.3975 33.9472 25.6097 33.8268 25.7627 33.6462C25.9158 33.4657 25.9999 33.2367 26 33V29C25.9999 28.7633 25.9158 28.5343 25.7627 28.3538C25.6097 28.1732 25.3975 28.0528 25.164 28.014L22.384 27.55C22.292 27.294 22.184 27.044 22.078 26.8L23.712 24.51C23.8496 24.3175 23.9144 24.0824 23.895 23.8466C23.8756 23.6108 23.7732 23.3894 23.606 23.222L20.778 20.4C20.6106 20.2328 20.3893 20.1304 20.1534 20.111C19.9176 20.0916 19.6825 20.1564 19.49 20.294L17.2 21.928C16.956 21.818 16.706 21.714 16.45 21.622L15.986 18.842C15.9485 18.6074 15.8286 18.3938 15.648 18.2395C15.4673 18.0853 15.2376 18.0003 15 18H14V3.298C14.0005 2.95391 14.1375 2.62407 14.3808 2.38076C14.6241 2.13745 14.9539 2.00053 15.298 2H38V11C38 11.2652 38.1054 11.5196 38.2929 11.7071C38.4804 11.8946 38.7348 12 39 12H48V46.702C47.9995 47.0461 47.8625 47.3759 47.6192 47.6192C47.3759 47.8625 47.0461 47.9995 46.702 48Z",
  fill: "url(#paint110_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 31C19 29.8133 18.6481 28.6533 17.9888 27.6666C17.3295 26.6799 16.3925 25.9109 15.2961 25.4567C14.1997 25.0026 12.9933 24.8838 11.8295 25.1153C10.6656 25.3468 9.59648 25.9182 8.75736 26.7574C7.91825 27.5965 7.3468 28.6656 7.11529 29.8295C6.88378 30.9933 7.0026 32.1997 7.45673 33.2961C7.91085 34.3925 8.67989 35.3295 9.66658 35.9888C10.6533 36.6481 11.8133 37 13 37C14.5913 37 16.1174 36.3679 17.2426 35.2426C18.3679 34.1174 19 32.5913 19 31ZM9 31C9 30.2089 9.2346 29.4355 9.67412 28.7777C10.1136 28.1199 10.7384 27.6072 11.4693 27.3045C12.2002 27.0017 13.0044 26.9225 13.7804 27.0769C14.5563 27.2312 15.269 27.6122 15.8284 28.1716C16.3878 28.731 16.7688 29.4437 16.9231 30.2196C17.0775 30.9956 16.9983 31.7998 16.6955 32.5307C16.3928 33.2616 15.8801 33.8864 15.2223 34.3259C14.5645 34.7654 13.7911 35 13 35C11.9391 35 10.9217 34.5786 10.1716 33.8284C9.42143 33.0783 9 32.0609 9 31Z",
  fill: "url(#paint111_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19 12H33C33.2652 12 33.5196 11.8946 33.7071 11.7071C33.8946 11.5196 34 11.2652 34 11C34 10.7348 33.8946 10.4804 33.7071 10.2929C33.5196 10.1054 33.2652 10 33 10H19C18.7348 10 18.4804 10.1054 18.2929 10.2929C18.1054 10.4804 18 10.7348 18 11C18 11.2652 18.1054 11.5196 18.2929 11.7071C18.4804 11.8946 18.7348 12 19 12Z",
  fill: "url(#paint112_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43 16H19C18.7348 16 18.4804 16.1054 18.2929 16.2929C18.1054 16.4804 18 16.7348 18 17C18 17.2652 18.1054 17.5196 18.2929 17.7071C18.4804 17.8946 18.7348 18 19 18H43C43.2652 18 43.5196 17.8946 43.7071 17.7071C43.8946 17.5196 44 17.2652 44 17C44 16.7348 43.8946 16.4804 43.7071 16.2929C43.5196 16.1054 43.2652 16 43 16Z",
  fill: "url(#paint113_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29 24H33C33.2652 24 33.5196 23.8946 33.7071 23.7071C33.8946 23.5196 34 23.2652 34 23C34 22.7348 33.8946 22.4804 33.7071 22.2929C33.5196 22.1054 33.2652 22 33 22H29C28.7348 22 28.4804 22.1054 28.2929 22.2929C28.1054 22.4804 28 22.7348 28 23C28 23.2652 28.1054 23.5196 28.2929 23.7071C28.4804 23.8946 28.7348 24 29 24Z",
  fill: "url(#paint114_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M43 22H37C36.7348 22 36.4804 22.1054 36.2929 22.2929C36.1054 22.4804 36 22.7348 36 23C36 23.2652 36.1054 23.5196 36.2929 23.7071C36.4804 23.8946 36.7348 24 37 24H43C43.2652 24 43.5196 23.8946 43.7071 23.7071C43.8946 23.5196 44 23.2652 44 23C44 22.7348 43.8946 22.4804 43.7071 22.2929C43.5196 22.1054 43.2652 22 43 22Z",
  fill: "url(#paint115_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M43 28H29C28.7348 28 28.4804 28.1054 28.2929 28.2929C28.1054 28.4804 28 28.7348 28 29C28 29.2652 28.1054 29.5196 28.2929 29.7071C28.4804 29.8946 28.7348 30 29 30H43C43.2652 30 43.5196 29.8946 43.7071 29.7071C43.8946 29.5196 44 29.2652 44 29C44 28.7348 43.8946 28.4804 43.7071 28.2929C43.5196 28.1054 43.2652 28 43 28Z",
  fill: "url(#paint116_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M43 34H29C28.7348 34 28.4804 34.1054 28.2929 34.2929C28.1054 34.4804 28 34.7348 28 35C28 35.2652 28.1054 35.5196 28.2929 35.7071C28.4804 35.8946 28.7348 36 29 36H43C43.2652 36 43.5196 35.8946 43.7071 35.7071C43.8946 35.5196 44 35.2652 44 35C44 34.7348 43.8946 34.4804 43.7071 34.2929C43.5196 34.1054 43.2652 34 43 34Z",
  fill: "url(#paint117_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M37 40H29C28.7348 40 28.4804 40.1054 28.2929 40.2929C28.1054 40.4804 28 40.7348 28 41C28 41.2652 28.1054 41.5196 28.2929 41.7071C28.4804 41.8946 28.7348 42 29 42H37C37.2652 42 37.5196 41.8946 37.7071 41.7071C37.8946 41.5196 38 41.2652 38 41C38 40.7348 37.8946 40.4804 37.7071 40.2929C37.5196 40.1054 37.2652 40 37 40Z",
  fill: "url(#paint118_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M43 40H41C40.7348 40 40.4804 40.1054 40.2929 40.2929C40.1054 40.4804 40 40.7348 40 41C40 41.2652 40.1054 41.5196 40.2929 41.7071C40.4804 41.8946 40.7348 42 41 42H43C43.2652 42 43.5196 41.8946 43.7071 41.7071C43.8946 41.5196 44 41.2652 44 41C44 40.7348 43.8946 40.4804 43.7071 40.2929C43.5196 40.1054 43.2652 40 43 40Z",
  fill: "url(#paint119_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint110_linear",
  x1: -4.224,
  y1: 57.894,
  x2: 53.146,
  y2: 4.318,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint111_linear",
  x1: -32.696,
  y1: 355.72,
  x2: 311.524,
  y2: 34.276,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint112_linear",
  x1: -66.288,
  y1: 60.92,
  x2: -51.1642,
  y2: -52.0646,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint113_linear",
  x1: -49.782,
  y1: 72.62,
  x2: -40.3722,
  y2: -41.6138,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint114_linear",
  x1: 21.334,
  y1: 81.824,
  x2: 57.7494,
  y2: -20.1902,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint115_linear",
  x1: 43.88,
  y1: 86.314,
  x2: 72.6123,
  y2: -21.0069,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint116_linear",
  x1: 52.8,
  y1: 93.524,
  x2: 67.9248,
  y2: -19.4646,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint117_linear",
  x1: 76.752,
  y1: 102.73,
  x2: 91.8752,
  y2: -10.2544,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint118_linear",
  x1: 66.44,
  y1: 110.438,
  x2: 89.9929,
  y2: 0.469283,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint119_linear",
  x1: 63.764,
  y1: 114.928,
  x2: 111.622,
  y2: 25.5427,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})));

function SvgProccesing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProccesing);
export default __webpack_public_path__ + "static/media/proccesing.654addc6.svg";
export { ForwardRef as ReactComponent };